import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as chatService from '../services/chatService';

/**
 * Hook para buscar sessões de chat com cache
 */
export function useChatSessions(skip: number = 0, limit: number = 25) {
  return useQuery({
    queryKey: ['chatSessions', skip, limit],
    queryFn: () => chatService.getChatSessions(skip, limit),
    staleTime: 2 * 60 * 1000, // 2 minutos (chat mais dinâmico)
  });
}

/**
 * Hook para buscar uma sessão específica com mensagens
 */
export function useChatSession(sessionId: string | undefined) {
  return useQuery({
    queryKey: ['chatSession', sessionId],
    queryFn: () => sessionId ? chatService.getChatSession(sessionId) : Promise.reject('No ID'),
    enabled: !!sessionId,
    staleTime: 1 * 60 * 1000, // 1 minuto
    refetchInterval: 30000, // Refetch a cada 30s se a página estiver ativa
  });
}

/**
 * Hook para criar nova sessão de chat
 */
export function useCreateChatSession() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: chatService.createChatSession,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chatSessions'] });
    },
  });
}

/**
 * Hook para deletar sessão
 */
export function useDeleteChatSession() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (sessionId: string) => chatService.deleteChatSession(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chatSessions'] });
    },
  });
}
